import { Injectable } from '@angular/core'
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar'

@Injectable({
  providedIn: 'root',
})
export class AdminToastService {
  private readonly defaultConfig: MatSnackBarConfig = {
    duration: 4000,
    horizontalPosition: 'right',
    verticalPosition: 'bottom',
  }

  private readonly actionLabel = 'Rendben'

  constructor(private snackBar: MatSnackBar) {}

  showSuccess(message: string): void {
    this.open(message)
  }

  showInfo(message: string): void {
    this.open(message)
  }

  showError(message: string): void {
    this.open(message)
  }

  private open(message: string): void {
    this.snackBar.open(message, this.actionLabel, this.defaultConfig)
  }
}
